import React, { useEffect, useState, useContext } from 'react';

import PropTypes from 'prop-types';
import Row from './Row';
import { Modal } from '@telus-uds/components-web';
import DefectSummary from './DefectSummary/DefectSummary';
import { GlobalContext } from '../design/layout';
import request from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { DefectModalStyle } from './css';
import { StickyOrderModalHeader } from '../design/shared/modalOverrides';

const Table = ({
  setFetchData,
  header = {},
  data = [],
  userProfile,
  defectId,
  onDefectSelected,
  tableCaption
}) => {
  const { setDefectNotificationCount } = useContext(GlobalContext);
  const {
    DEFECT_MANAGEMENT: { VIEW_DEFECT }
  } = useLocalizedStringsContext();

  const [selectedDefect, setSelectedDefect] = useState({});
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (defectId) {
      setOpenModal(true);
    }
  }, [defectId]);

  useEffect(() => {
    if (!openModal) {
      request
        .get('/defects/count')
        .then(res => {
          const {
            data: { notificationCount = '' }
          } = res;
          setDefectNotificationCount(notificationCount);
        })
        .catch(() => {});
    }
  }, [openModal]);

  return (
    <>
      <style>{DefectModalStyle}</style>
      <div className="responsive-table-container defect-table-container">
        <table className="responsive-table">
          <caption className="responsive-table__caption">
            {tableCaption}
          </caption>
          <thead className="responsive-table__thead">
            <tr>
              {Object.values(header).map(itemHeader => (
                <th key={itemHeader}>{itemHeader}</th>
              ))}
            </tr>
          </thead>
          <tbody className="responsive-table__tbody">
            {data &&
              data.map((defect, index) => (
                <Row
                  key={defect.id}
                  index={index}
                  defect={defect}
                  selectedDefect={selected => {
                    setSelectedDefect(selected);
                    onDefectSelected(selected);
                  }}
                  openModal={setOpenModal}
                  userProfile={userProfile}
                  headers={Object.values(header)}
                />
              ))}
          </tbody>
        </table>
      </div>

      <Modal
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
          setFetchData(true);
          setSelectedDefect({});
          onDefectSelected({});
        }}
        heading={VIEW_DEFECT}
        variant={{ width: 'xl' }}
        className="defect-management-modal"
      >
        {openModal && <StickyOrderModalHeader />}
        <DefectSummary
          setFetchData={setFetchData}
          defectId={defectId}
          openModal={setOpenModal}
          defect={selectedDefect}
          userProfile={userProfile}
        />
      </Modal>
    </>
  );
};

Table.propTypes = {
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  header: PropTypes.objectOf(PropTypes.any).isRequired,
  setFetchData: PropTypes.func.isRequired,
  userProfile: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    role: PropTypes.shape({ name: PropTypes.string })
  }).isRequired,
  defectId: PropTypes.number.isRequired,
  onDefectSelected: PropTypes.bool.isRequired,
  tableCaption: PropTypes.string.isRequired
};

export default Table;
